import { FC, useEffect, useState } from "react";
import "./RevampOnboardingPopup.scss";
import CustomPopup from "../../components/CustomPopup/CustomPopup";
import {
  Box,
  Button,
  InputAdornment,
  Radio,
  TextField,
  Typography,
} from "@mui/material";
import useWindowSize from "../../hooks/useWindowSize";
import {
  ABCDHoldingsLobCode,
  customEmailRegex,
  DEVICE_TYPE,
  GTAScreenType,
  HiLobCode,
  invalidDOBHelperText,
  invalidDOBValidationHelperText,
  invalidEmailHelperText,
  inValidPanHelperText,
  invalidPANValidationHelperText,
  LiLobCode,
  MfLobCode,
  onUserLoginCleverTapStatic,
  panRegex,
  PersonalLoansLobCode,
  SCREEN_TYPE,
  tabViewPoint,
  userLables,
} from "../../utils/constants";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { Colors, globalTextFieldSx } from "../../styles/constant";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { enUS } from "@mui/x-date-pickers/locales";
import { useAppSelector } from "../../redux-store/CustomReduxHooks";
import cleverTap, { triggerCleverTapEvent } from "../../utils/CleverTap";
import TriggerGTAEvent from "../../utils/GTA";
import AlertRhombus from "../../assets/icons/alert-rhombus.svg";
import { E_ChannelOptions } from "../../globalTypes/GlobalTypes";
import {
  T_CustomerLobDetailObj,
  T_LobDetailsForUserRegPay,
} from "../../features/Feature_Login/Login_Types";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { isEmpty } from "lodash";
import {
  getMobileOperatingSystem,
  getRouteFromFuncCode,
  getValidNameFromCustomerAndLobDetails,
} from "../../utils/helper";
import { updateOnboardingLoadingState } from "../../features/Feature_Loading/Loading_Slice";
import {
  clearCustomerAndLobDetailsArr,
  saveCiiNoFromTerraData,
} from "../../redux-store/reducers/CsAppSlice";
import { setError } from "../../redux-store/reducers/CsErrorSlice";
import { R_HomeRoutes } from "../../utils/Routes";
import { useLazyTeraDataUserRegistrationQuery } from "../../features/Feature_OnBoarding/OnBoarding_Api";
import { useDispatch } from "react-redux";
import useDeviceDetection from "../../hooks/useDeviceDetection";
import { useNavigate } from "react-router-dom";
import useSaveChatbotActivity from "../../hooks/useSaveChatbotActivity";
import RevampOnboardingLoader from "./RevampOnboardingLoader";
import { useLazyFetchOnboardingAnimationsQuery } from "../../features/Features_Cms/Cms_Api";
import { setOnboardingAnimations } from "../../features/Features_Cms/Feature_Cms_Slice";
import TodayIcon from "@mui/icons-material/Today";
import { getOnboardingChannelId, maskPAN } from "../../utils/conversionUtils";

dayjs.extend(customParseFormat);
const usLocale =
  enUS.components.MuiLocalizationProvider.defaultProps.localeText;

interface Props {
  open: boolean;
  handleOpen: Function;
  fromChatBot?: boolean;
}

const RevampOnboardingPopup: FC<Props> = ({
  open,
  handleOpen,
  fromChatBot = false,
}) => {
  const navigate = useNavigate();
  const deviceType = useDeviceDetection();
  const appDispatch = useDispatch();
  const { width } = useWindowSize();
  const ssoSlice = useAppSelector((state) => state.SsoSlice.ssoData);
  const masterData = useAppSelector(
    (state) => state.GeneralAppElementsSlice?.masterData,
  );
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const channel = csAppSlice.channel;
  const secondaryChannel_Slice = useAppSelector(
    (state) => state.SecondaryChannelSlice,
  );
  const [popUpFlow, setPopUpFlow] = useState<string>("dob");
  const [pan, setPan] = useState<string>(ssoSlice?.panNumber || "");
  const [dob, setDob] = useState<Dayjs | null>(
    ssoSlice?.customerDob
      ? dayjs(dayjs(ssoSlice?.customerDob, "DD/MM/YYYY").format("DD MMM YYYY"))
      : null,
  );
  const [email, setEmail] = useState<string>(ssoSlice?.emailId || "");
  const [helperTextPan, setHelperTextPan] = useState<string>("");
  const [helperTextDob, setHelperTextDob] = useState<string | null>("");
  const [helperTextEmail, setHelperTextEmail] = useState<string>("");
  const [isDobVerified, setIsDobVerified] = useState<boolean | null>(null);
  const [isSecondTime, setIsSecondTime] = useState<boolean>(false);
  const userDetails = useAppSelector((st) => st.CsAppSlice.userDetails);
  const [verifiedCustomerData, setVerifiedCustomerData] = useState<
    T_CustomerLobDetailObj[] | null
  >(null);
  const [availablePANs, setAvailablePANs] = useState<string[]>([]);
  const [selectedPAN, setSelectedPAN] = useState<string | null>(null);
  const [btnLoading, setBtnLoading] = useState<boolean>(false);
  const [teraDataUserRegistration] = useLazyTeraDataUserRegistrationQuery();
  const { callSaveChatbotActivityAndRedirect } = useSaveChatbotActivity();
  const [fetchOnboardingAnimations] = useLazyFetchOnboardingAnimationsQuery();
  const [preLoadedGif, setPreLoadedGif] = useState<any[]>([]);

  const fetchAnimationData = async (url: string) => {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to fetch animation data");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching animation JSON:", error);
    }
  };

  useEffect(() => {
    fetchOnboardingAnimations().then((res) => {
      if (res.isSuccess && res.data) {
        appDispatch(setOnboardingAnimations(res.data?.payload?.data));
        if (!isEmpty(res.data.payload.data)) {
          const animationPromises = res.data.payload.data.map((item) =>
            item.attributes?.animation.data?.attributes?.url
              ? fetchAnimationData(
                  item.attributes.animation.data.attributes.url,
                )
              : Promise.resolve(null),
          );
          Promise.all(animationPromises).then((animations) => {
            const tempArray = animations.filter((item) => item !== null);
            setPreLoadedGif(tempArray);
          });
        }
      }
    });
  }, []);

  const clearAllData = () => {
    setPopUpFlow("dob");
    setDob(null);
    setPan("");
    setSelectedPAN("");
    setVerifiedCustomerData([]);
    setAvailablePANs([]);
    setHelperTextDob("");
    setHelperTextPan("");
    setEmail("");
    setHelperTextEmail("");
  };

  useEffect(() => {
    if (isSecondTime && verifiedCustomerData) {
      handleSubmit(verifiedCustomerData, false);
    }
  }, [isSecondTime, verifiedCustomerData]);

  const handleClosePopUp = () => {
    clearAllData();
    handleOpen(false);
  };

  const handleClevertapEvent = (
    type: string,
    formFieldTitle?: string,
    formFieldValue?: string,
  ) => {
    triggerCleverTapEvent("serv_verify_user_details_form_field", {
      ScreenType: SCREEN_TYPE.generalAppType,
      ScreenName: "Servicing Personal Details Verification Screen",
      isPrevPageNameRequired: true,
      FormFieldTitle: formFieldTitle,
      FormFieldValue: formFieldValue,
    });
  };

  const handleGTMEvent = (
    type: string,
    formFieldTitle?: string,
    formFieldValue?: string,
  ) => {
    TriggerGTAEvent("serv_verify_user_details_form_field", {
      screen_type: GTAScreenType.PreLoginScreenType,
      screen_name: "servicing_personal_details_verification_screen",
      field_placeholder_text: formFieldTitle,
      field_placeholder_value: formFieldValue,
    });
  };

  const getLobRefId = (
    selectedLob: string,
    c: T_CustomerLobDetailObj,
    data: T_CustomerLobDetailObj[],
  ) => {
    let lobRefId = "";
    if (selectedLob === LiLobCode) {
      lobRefId = c?.LOBID || "";
    } else if (selectedLob === HiLobCode) {
      lobRefId = c.LOBID;
    } else if (selectedLob === MfLobCode) {
      lobRefId = c.PAN || "";
    } else if (selectedLob === ABCDHoldingsLobCode) {
      lobRefId = c.LOBID;
    } else if (selectedLob === PersonalLoansLobCode) {
      let matchedPanObj = data.filter(
        (item) => item.LOB === PersonalLoansLobCode && pan === item.PAN,
      );
      lobRefId = isEmpty(matchedPanObj) ? "" : matchedPanObj[0].PAN;
    }
    return lobRefId;
  };

  const allowedChannels = [
    E_ChannelOptions.SUPER_APP,
    E_ChannelOptions.ONE_ABC,
    E_ChannelOptions.ABSLI,
    E_ChannelOptions.ABHI,
    E_ChannelOptions.ABSLAMC,
    E_ChannelOptions.ABML,
    E_ChannelOptions.ABHFL,
    E_ChannelOptions.ABFL,
  ];

  const mobileNumber = useAppSelector((state) =>
    allowedChannels.includes(channel)
      ? state.SsoSlice?.ssoData?.mobileNo
      : state.LoginSlice?.mobilenumber,
  );

  const lobsToSkipPanDobMatching = [ABCDHoldingsLobCode, PersonalLoansLobCode];

  const validateDOB = (value: Dayjs | null) => {
    if (!value) {
      setIsDobVerified(false);
      setHelperTextDob(invalidDOBHelperText);
      setVerifiedCustomerData(null);
      return;
    }

    const customerDetails = userDetails?.customerAndLobDetails || [];

    // Case: Only one ABCD/ABFL holding exists → directly go to PAN flow after DOB verification
    const holdingsToSkipMatching = customerDetails?.filter((d) =>
      [ABCDHoldingsLobCode].includes(d?.LOB),
    );
    const holdingsToMatching = customerDetails?.filter(
      (d) => ![ABCDHoldingsLobCode].includes(d?.LOB),
    );
    if (holdingsToSkipMatching.length && holdingsToMatching.length === 0) {
      const updatedHoldings = holdingsToSkipMatching.map((item) => ({
        ...item,
        DOB: value.format("YYYY-MM-DD"),
      }));
      setVerifiedCustomerData(updatedHoldings);
      setIsDobVerified(true);
      setHelperTextDob("");
      setPopUpFlow("pan");
      return;
    }

    const formattedDOB = value.format("YYYY-MM-DD");

    // Customers matching DOB
    const matchedCustomers = customerDetails?.filter(
      (c) => dayjs(c?.DOB).format("YYYY-MM-DD") === formattedDOB,
    );

    if (isEmpty(matchedCustomers)) {
      setIsDobVerified(false);
      setHelperTextDob(invalidDOBValidationHelperText);
      setVerifiedCustomerData(null);
      return;
    }

    // --- Single Customer Match ---
    if (matchedCustomers.length === 1) {
      const matched = matchedCustomers[0];
      const isPanValid = matched?.PAN && panRegex.test(matched.PAN);
      const isEmailIdValid =
        matched?.EMAIL && customEmailRegex.test(matched?.EMAIL);

      setIsDobVerified(true);
      setHelperTextDob("");
      setVerifiedCustomerData(matchedCustomers);

      if (isPanValid) {
        setPan(matched?.PAN);
        setIsSecondTime(true);
        if (isEmailIdValid) {
          setEmail(matched?.EMAIL);
        } else {
          setPopUpFlow("email");
        }
      } else {
        setPopUpFlow("pan");
      }
      return;
    }

    // --- Multiple Customer Matches ---
    const validPANs = matchedCustomers
      .map((c) => c?.PAN?.toUpperCase())
      .filter((pan) => panRegex.test(pan));

    setIsDobVerified(true);
    setHelperTextDob("");
    setVerifiedCustomerData(matchedCustomers);

    if (isEmpty(validPANs)) {
      setPopUpFlow("pan");
      return;
    }

    const uniquePANs = Array.from(new Set(validPANs));

    if (uniquePANs.length === 1) {
      setPan(uniquePANs[0]);
      const matchedCustomers = customerDetails?.filter(
        (c) => c?.PAN === uniquePANs[0] && c?.EMAIL,
      );
      if (!isEmpty(matchedCustomers[0]?.EMAIL)) {
        setEmail(matchedCustomers[0]?.EMAIL);
      } else {
        setPopUpFlow("email");
        return;
      }
      setIsSecondTime(true);
    } else {
      setAvailablePANs(uniquePANs);
      setSelectedPAN(uniquePANs[0]);
      setPopUpFlow("confirmPanDetails");
    }
  };

  const handleDOBchange = (value: Dayjs | null) => {
    if (!value || value.isAfter(dayjs())) {
      setDob(null);
      setIsDobVerified(false);
      setHelperTextDob(invalidDOBHelperText);
      setVerifiedCustomerData(null);
      return;
    }

    if (dayjs(value).isAfter("1900-01-01") && value.isValid()) {
      setDob(value);
      setHelperTextDob("");
      handleClevertapEvent("formfield", "DOB", value.format("YYYY-MM-DD"));
      handleGTMEvent("formfield", "DOB", value.format("YYYY-MM-DD"));
    }
  };

  const handlePanChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const upperValue = value.toUpperCase();
    setPan(upperValue);

    if (upperValue.length === 10 && !panRegex.test(upperValue)) {
      setHelperTextPan(inValidPanHelperText);
    } else {
      setHelperTextPan("");
    }
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setEmail(value);

    if (!customEmailRegex.test(value)) {
      setHelperTextEmail(invalidEmailHelperText);
    } else {
      setHelperTextEmail("");
    }
  };

  const fetchLobRecords = (
    customerData: T_CustomerLobDetailObj[] | null,
    lobCode: string,
  ) => {
    return customerData?.find((item) => item?.LOB === lobCode);
  };

  const handleSubmit = (
    customerData?: T_CustomerLobDetailObj[],
    isUserEnteredPAN?: boolean,
    emailPassed?: string,
  ) => {
    if (popUpFlow === "dob" && dob && !isSecondTime) {
      TriggerGTAEvent("serv_2fa_dob_submit_click", {
        screen_type: GTAScreenType.PreLoginScreenType,
        screen_name: "servicing_personal_details_verification_screen",
      });
      validateDOB(dob);
      return;
    }

    if (
      (isEmpty(email) || !customEmailRegex.test(email)) &&
      isEmpty(emailPassed)
    ) {
      setPopUpFlow("email");
      return;
    }

    const finalData = customerData || verifiedCustomerData;
    if (!finalData?.length) return;

    setBtnLoading(true);

    let panNo = "";
    let emailId = "";
    if (finalData.length === 1) {
      panNo = finalData[0].PAN || pan;
      emailId = finalData[0].EMAIL || email;
    } else {
      panNo = pan;
      emailId = email || emailPassed || "";
    }

    const dobData = finalData[0]?.DOB || "";
    const customerName =
      getValidNameFromCustomerAndLobDetails(
        dob,
        pan,
        userDetails?.customerAndLobDetails || [],
      ) || "";

    let onUserLoginCleverTapData = { ...onUserLoginCleverTapStatic };
    onUserLoginCleverTapData["Identity"] = csAppSlice.csUserId;
    onUserLoginCleverTapData["Email"] = emailId;
    onUserLoginCleverTapData["Phone"] = "+91" + mobileNumber;
    onUserLoginCleverTapData["DOB"] = new Date(dobData);
    onUserLoginCleverTapData["MSG-email"] = !isEmpty(emailId);
    onUserLoginCleverTapData["MSG-sms"] = true;
    onUserLoginCleverTapData["MSG-whatsapp"] = true;
    onUserLoginCleverTapData["MSG-push"] = !isEmpty(
      csAppSlice.NativeDeviceInfo?.deviceName,
    );
    cleverTap.onUserLogin.push({ Site: onUserLoginCleverTapData });
    triggerCleverTapEvent("onUserLogin", {
      ScreenType: SCREEN_TYPE.generalAppType,
      ScreenName: "Servicing Personal Details Verification Screen",
      isPrevPageNameRequired: true,
      ...onUserLoginCleverTapData,
      MSG_email: onUserLoginCleverTapData["MSG-email"],
      MSG_push: onUserLoginCleverTapData["MSG-push"],
      MSG_sms: onUserLoginCleverTapData["MSG-sms"],
      MSG_whatsapp: onUserLoginCleverTapData["MSG-whatsapp"],
    });
    triggerCleverTapEvent("serv_verify_user_details_submit", {
      ScreenType: SCREEN_TYPE.generalAppType,
      ScreenName: "Servicing Personal Details Verification Screen",
      isPrevPageNameRequired: true,
      ctaText: "continue",
    });
    TriggerGTAEvent("serv_verify_user_details_submit", {
      screen_type: GTAScreenType.PreLoginScreenType,
      screen_name: "servicing_personal_details_verification_screen",
      CTA_text: "continue",
    });

    let abcPwd = "",
      pwdType = "";
    const lobIds: T_LobDetailsForUserRegPay[] = [];

    finalData?.forEach((lobDetails) => {
      let isPanOrDobMatched: "panAndDob" | "dob" | "" = "";
      if (!lobsToSkipPanDobMatching.includes(lobDetails?.LOB)) {
        if (
          !isEmpty(lobDetails.PAN) &&
          panRegex.test(lobDetails.PAN || "") &&
          !isUserEnteredPAN
        ) {
          if (
            lobDetails.PAN === pan &&
            dayjs(lobDetails.DOB).format("YYYY-MM-DD") ===
              dob?.format("YYYY-MM-DD")
          ) {
            isPanOrDobMatched = "panAndDob";
          }
        } else if (
          /** Goto DOB validation only if PAN for current LOB is empty or lob provided PAN is not matched with regex */
          dayjs(lobDetails.DOB).format("YYYY-MM-DD") ===
          dob?.format("YYYY-MM-DD")
        ) {
          isPanOrDobMatched = "dob";
        }
      } else {
        isPanOrDobMatched = "panAndDob";
      }

      if (isPanOrDobMatched == "panAndDob" || isPanOrDobMatched == "dob") {
        const selectedLob = masterData?.productCategory?.find(
          (item) => item.lob === lobDetails.LOB,
        );
        const lobRefId = getLobRefId(
          lobDetails.LOB,
          lobDetails,
          userDetails?.customerAndLobDetails || [],
        );
        const selectedLobId = selectedLob?.lobId || "";
        if (
          !lobIds.find(
            (l) => l.lobRefId === lobRefId && l.lobCode === selectedLobId,
          )
        ) {
          lobIds.push({
            lobRefId: lobRefId,
            lobCode: selectedLobId,
          });
        }
        // if (customerName?.length <= 0 && lobDetails?.NAME) {
        //   customerName = lobDetails.NAME;
        // }
        if (abcPwd?.length <= 0) {
          abcPwd =
            isPanOrDobMatched === "panAndDob"
              ? pan
              : isPanOrDobMatched === "dob" && dob
                ? dob.format("YYYY/MM/DD")
                : "";
          pwdType =
            isPanOrDobMatched === "panAndDob" ? userLables.PAN : userLables.DOB;
        }
      }
    });

    const isSuccess =
      (abcPwd?.length > 0 && lobIds.length > 0) || !isEmpty(finalData);

    if (isSuccess) {
      const abcUserId = emailId;
      doNewUserOnboarding(
        abcUserId,
        abcPwd,
        pwdType,
        lobIds,
        panNo,
        dobData,
        emailId,
        customerName,
        finalData,
      );
    }
  };

  const doNewUserOnboarding = (
    abcUserId: string,
    abcPwd: string,
    pwdType: string,
    userLobsDetails: T_LobDetailsForUserRegPay[],
    panNo: string,
    dobData: string,
    emailId: string,
    customerName: string,
    customerData: T_CustomerLobDetailObj[],
  ) => {
    const existingCiiNo =
      customerData?.find(
        (c) => c.PRIMARY_SECONDARY_USER === "primary" && !isEmpty(c.CII),
      )?.CII || "";
    const onboardingChannelId = getOnboardingChannelId(csAppSlice.channel);
    teraDataUserRegistration(
      {
        abcUserId: abcUserId,
        abcPassword: abcPwd,
        passwordType: pwdType,
        mobileNo: "" + mobileNumber,
        userLobsDetails: userLobsDetails,
        dob: dobData,
        emailId: emailId,
        panNo: panNo,
        customerName: customerName,
        primarySecondaryUser: "primary",
        presentCiiNo: `${existingCiiNo}`,
        ciiNoPresent: existingCiiNo?.length > 0,
        onboardingChannel: onboardingChannelId,
        onboardingSource: isEmpty(onboardingChannelId) ? "26" : "",
        manualAddHoldingFlag: false,
        deviceId: csAppSlice.userAgent?.deviceId || "",
        deviceType:
          deviceType === DEVICE_TYPE.PWA_MOBILE ||
          deviceType === DEVICE_TYPE.MOBILE
            ? getMobileOperatingSystem()
            : "web",
        mobileOs: getMobileOperatingSystem(),
        appVersion: csAppSlice.NativeDeviceInfo?.appVersion || "",
        browser: csAppSlice.userAgent?.browserName || "",
        browserVersion: csAppSlice.userAgent?.browserVersion || "",
        mobileModel: csAppSlice.NativeDeviceInfo?.deviceName || "",
        mobileMakeModel: csAppSlice.NativeDeviceInfo?.deviceModel || "",
        mobileOsVersion:
          csAppSlice.NativeDeviceInfo?.systemVersion.toString() || "",
        hasHoldings: !isEmpty(userDetails?.customerAndLobDetails),
      },
      false,
    ).then((r) => {
      if (r.isSuccess) {
        setBtnLoading(false);
        appDispatch(
          updateOnboardingLoadingState({
            loading: true,
            showOnboardingText: false,
          }),
        );
        appDispatch(clearCustomerAndLobDetailsArr());
        appDispatch(saveCiiNoFromTerraData(r?.data?.payload?.CII)); //added this for SAS-1791
        if (fromChatBot) {
          callSaveChatbotActivityAndRedirect();
        }
        if (channel === E_ChannelOptions.SUPER_APP) {
          const routeForFuncCode = getRouteFromFuncCode(
            "" + ssoSlice.functionality,
            false,
          );
          navigate(routeForFuncCode || R_HomeRoutes.home, { replace: true });
        } else if (channel === E_ChannelOptions.SECONDARY_CHANNEL) {
          navigate(secondaryChannel_Slice.constructedAppUrl, {
            state: secondaryChannel_Slice.dynamicState,
            replace: true,
          });
        } else {
          navigate(R_HomeRoutes.home, { replace: true });
        }
      } else if (r.error) {
        const e = r.error as Error;
        setBtnLoading(false);
        appDispatch(setError({ error: e, message: e.message }));
        appDispatch(
          updateOnboardingLoadingState({
            loading: false,
            showOnboardingText: false,
          }),
        );
      }
    });
  };

  const renderDOBFlow = () => (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap="1.5rem"
    >
      <Box display="flex" flexDirection="column" gap=".5rem">
        <Typography
          variant="h5"
          color={Colors.darkCharcoal}
          letterSpacing=".0938rem"
        >
          ONE-TIME VERIFICATION
        </Typography>
        <Typography
          variant="h5"
          fontWeight={400}
          color={Colors.descriptionGray}
        >
          Enter your registered Date of birth <br /> to view your holdings
        </Typography>
      </Box>

      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        localeText={{
          ...usLocale,
          fieldMonthPlaceholder: (params) =>
            params.contentType === "letter" ? "MMM" : "MM",
        }}
      >
        <DesktopDatePicker
          label="Date of birth"
          format="DD-MM-YYYY"
          className="date-picker"
          value={dob ? dayjs(dob, "DD-MM-YYYY") : null}
          onError={(error) =>
            error
              ? setHelperTextDob(invalidDOBHelperText)
              : setHelperTextDob(null)
          }
          onChange={handleDOBchange}
          onOpen={() => {
            TriggerGTAEvent("serv_2fa_dob_calender_icon_click", {
              screen_type: GTAScreenType.DashboardScreenType,
              screen_name: "servicing_personal_details_verification_screen",
            });
          }}
          disableFuture
          views={["year", "month", "day"]}
          sx={globalTextFieldSx}
          slots={{
            openPickerIcon: TodayIcon, // <-- Override default calendar icon
          }}
          slotProps={{
            textField: ({ InputProps }) => ({
              error: !!helperTextDob,
              autoComplete: "new-password",
              helperText: helperTextDob?.length ? (
                <span style={{ display: "flex", alignItems: "center" }}>
                  <InputAdornment position="start">
                    {helperTextDob && <img src={AlertRhombus} />}
                  </InputAdornment>
                  {helperTextDob}
                </span>
              ) : null,
              onBlur: (e) => {
                const typedValue = e.target.value;
                const parsed = dayjs(typedValue, "DD-MM-YYYY", true);
                if (parsed.isValid()) {
                  TriggerGTAEvent("serv_2fa_dob_form_field", {
                    screen_type: GTAScreenType.PreLoginScreenType,
                    screen_name:
                      "servicing_personal_details_verification_screen",
                    field_placeholder_text: "DOB",
                    field_placeholder_value: "dob_entered",
                  });
                  handleDOBchange(parsed);
                } else {
                  setIsDobVerified(false);
                  setHelperTextDob(invalidDOBHelperText);
                  setVerifiedCustomerData(null);
                }
              },
              InputProps: {
                ...InputProps,
                endAdornment: (
                  <>
                    {isDobVerified === true ? (
                      <InputAdornment position="end">
                        <CheckCircleIcon sx={{ color: Colors.green }} />
                      </InputAdornment>
                    ) : (
                      InputProps?.endAdornment
                    )}
                  </>
                ),
              },
            }),
            popper: {
              placement: width < tabViewPoint ? "top" : "auto",
              modifiers: [
                {
                  name: "flip",
                  enabled: false,
                },
                {
                  name: "preventOverflow",
                  options: {
                    altBoundary: true,
                    rootBoundary: "viewport",
                    tether: false,
                  },
                },
              ],
            },
            openPickerButton: {
              sx: {
                color: isEmpty(helperTextDob)
                  ? Colors.darkCharcoal
                  : Colors.red, // Apply color to the calendar icon
              },
            },
          }}
        />
      </LocalizationProvider>

      <Button
        variant="contained"
        fullWidth
        disabled={!dob || !!helperTextDob}
        onClick={() => handleSubmit()}
      >
        Submit
      </Button>
    </Box>
  );

  const renderPANFlow = () => (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap="1.5rem"
    >
      <Box display="flex" flexDirection="column" gap=".5rem">
        <Typography
          variant="h5"
          color={Colors.darkCharcoal}
          letterSpacing=".0938rem"
        >
          PROVIDE PAN DETAILS
        </Typography>
        <Typography
          variant="h5"
          fontWeight={400}
          color={Colors.descriptionGray}
        >
          Enter your PAN to proceed
        </Typography>
      </Box>

      <TextField
        fullWidth
        label="PAN"
        value={pan}
        onBlur={(e) => {
          if (!panRegex.test(e.target.value?.toUpperCase())) {
            setHelperTextPan(inValidPanHelperText);
          }
        }}
        onChange={handlePanChange}
        error={helperTextPan.length > 0}
        helperText={
          <span style={{ display: "flex", alignItems: "center" }}>
            <InputAdornment position="start">
              {helperTextPan.length > 0 && <img src={AlertRhombus} />}
            </InputAdornment>
            {helperTextPan}
          </span>
        }
        inputProps={{
          maxLength: 10,
          inputMode: "text",
          pattern: panRegex,
          style: { textTransform: "uppercase" },
        }}
        sx={globalTextFieldSx}
      />

      <Button
        variant="contained"
        fullWidth
        disabled={!panRegex.test(pan)}
        onClick={() => {
          const updatedCustomerData = (verifiedCustomerData || []).map((c) => ({
            ...c,
            PAN: pan.toUpperCase(),
          }));

          if (!isEmpty(updatedCustomerData)) {
            setVerifiedCustomerData(updatedCustomerData);
            const isEmailIdValid = updatedCustomerData?.find(
              (item) => item?.EMAIL,
            );
            if (!isEmpty(isEmailIdValid?.EMAIL)) {
              setEmail(isEmailIdValid?.EMAIL || "");
              handleSubmit(updatedCustomerData, true, isEmailIdValid?.EMAIL);
            } else {
              setVerifiedCustomerData(updatedCustomerData);
              setPopUpFlow("email");
              return;
            }
          } else {
            setPopUpFlow("please try again later!");
          }
        }}
      >
        Submit
      </Button>
    </Box>
  );

  const renderConfirmPANFlow = () => (
    <Box display="flex" flexDirection="column" padding="1rem">
      <Box display="flex" flexDirection="column" gap="1.5rem">
        <Typography
          variant="h5"
          color={Colors.darkCharcoal}
          letterSpacing=".0938rem"
        >
          CONFIRM PAN DETAILS
        </Typography>

        {/* DOB (readonly) */}
        <TextField
          label="Date of birth"
          value={dob ? dayjs(dob, "DD-MM-YYYY").format("DD-MM-YYYY") : ""}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <CheckCircleIcon sx={{ color: Colors.green }} />
              </InputAdornment>
            ),
          }}
          helperText={null}
          sx={{
            "& .MuiInputBase-root": {
              backgroundColor: "#E6E6E6",
            },
            "& .MuiInputLabel-shrink": {
              backdropFilter: "blur(4px)",
              color: `${Colors.darkCharcoal}!important`,
              fontSize: "1rem",
              fontWeight: "400",
            },
          }}
        />

        {/* PAN selection */}
        <Box display="flex" flexDirection="column" gap="0.5rem">
          <Typography
            variant="h5"
            fontWeight={400}
            color={Colors.descriptionGray}
            sx={{ textAlign: "start !important" }}
          >
            We have found multiple PAN. Please select one.
          </Typography>

          {availablePANs.map((panValue) => (
            <Box
              key={panValue}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              border={`.125rem solid ${
                selectedPAN === panValue ? Colors.red : Colors.bgGray
              }`}
              borderRadius="1rem"
              padding="0.5rem 1rem"
              onClick={() => {
                TriggerGTAEvent("serv_2fa_pan_details_option_selected", {
                  screen_type: GTAScreenType.DashboardScreenType,
                  screen_name: "servicing_personal_details_verification_screen",
                });
                setSelectedPAN(panValue);
                setPan("");
                setHelperTextPan("");
              }}
              sx={{ cursor: "pointer" }}
            >
              <Typography variant="h4" fontWeight={400}>
                {maskPAN(panValue)}
              </Typography>
              <Radio
                checked={selectedPAN === panValue}
                onChange={() => {
                  setSelectedPAN(panValue);
                  setPan("");
                  setHelperTextPan("");
                }}
              />
            </Box>
          ))}
        </Box>

        {/* PAN input */}
        {selectedPAN && (
          <>
            <Box>
              <Typography
                variant="h5"
                fontWeight={400}
                color={Colors.descriptionGray}
                sx={{ textAlign: "start !important" }}
                marginBottom="1rem"
              >
                Please enter the selected PAN{" "}
              </Typography>
              <TextField
                fullWidth
                label="PAN"
                value={pan}
                onChange={(e) => {
                  const enteredPAN = e.target.value.toUpperCase();
                  setPan(enteredPAN);

                  if (enteredPAN.length === 10) {
                    if (!panRegex.test(enteredPAN)) {
                      setHelperTextPan(inValidPanHelperText);
                    } else if (enteredPAN !== selectedPAN) {
                      setHelperTextPan(invalidPANValidationHelperText);
                    } else {
                      setHelperTextPan("");
                    }
                    TriggerGTAEvent("serv_2fa_pan_form_field", {
                      screen_type: GTAScreenType.DashboardScreenType,
                      screen_name:
                        "servicing_personal_details_verification_screen",
                      field_placeholder_text: "pan",
                      field_placeholder_value: "pan_entered",
                    });
                  } else {
                    setHelperTextPan("");
                  }
                }}
                error={helperTextPan.length > 0}
                helperText={
                  helperTextPan && (
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <InputAdornment position="start">
                        <img src={AlertRhombus} />
                      </InputAdornment>
                      {helperTextPan}
                    </span>
                  )
                }
                inputProps={{
                  maxLength: 10,
                  style: { textTransform: "uppercase" },
                }}
                sx={globalTextFieldSx}
              />
            </Box>
          </>
        )}

        <Button
          variant="contained"
          fullWidth
          disabled={!selectedPAN || !panRegex.test(pan) || pan !== selectedPAN}
          onClick={() => {
            if (selectedPAN && pan === selectedPAN) {
              TriggerGTAEvent("serv_2fa_pan_submit_click", {
                screen_type: GTAScreenType.DashboardScreenType,
                screen_name: "servicing_personal_details_verification_screen",
              });
              const matchedEmailData: T_CustomerLobDetailObj[] = [];
              const panRecord = verifiedCustomerData?.find(
                (item) => item?.PAN === selectedPAN,
              );
              if (
                !isEmpty(panRecord) &&
                panRecord?.LOB !== PersonalLoansLobCode
              ) {
                matchedEmailData.push(panRecord);
              }
              const abcdRecord = fetchLobRecords(
                verifiedCustomerData,
                ABCDHoldingsLobCode,
              );

              const abflRecords = verifiedCustomerData?.filter(
                (item) => item?.LOB === PersonalLoansLobCode,
              );
              if (!isEmpty(abcdRecord)) {
                matchedEmailData.push(abcdRecord);
              }

              if (!isEmpty(abflRecords)) {
                abflRecords?.map((item) => {
                  matchedEmailData.push(item);
                });
              }

              if (!isEmpty(matchedEmailData[0]?.EMAIL)) {
                setEmail(matchedEmailData[0]?.EMAIL);
                handleSubmit(
                  matchedEmailData || [],
                  false,
                  matchedEmailData[0]?.EMAIL,
                );
              } else {
                setVerifiedCustomerData(matchedEmailData);
                setPopUpFlow("email");
                return;
              }
            } else {
              setHelperTextPan(invalidPANValidationHelperText);
            }
          }}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );

  const renderEmailFlow = () => {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        gap="1.5rem"
      >
        <Box display="flex" flexDirection="column" gap=".5rem">
          <Typography
            variant="h5"
            color={Colors.darkCharcoal}
            letterSpacing=".0938rem"
          >
            PROVIDE EMAIL DETAILS
          </Typography>
          <Typography
            variant="h5"
            fontWeight={400}
            color={Colors.descriptionGray}
          >
            Enter your EMAIL to proceed
          </Typography>
        </Box>

        <TextField
          fullWidth
          label="EMAIL"
          value={email}
          onBlur={(e) => {
            if (!customEmailRegex.test(e.target.value)) {
              setHelperTextEmail(invalidEmailHelperText);
            }
          }}
          onChange={handleEmailChange}
          error={helperTextEmail.length > 0}
          helperText={
            <span style={{ display: "flex", alignItems: "center" }}>
              <InputAdornment position="start">
                {helperTextEmail.length > 0 && <img src={AlertRhombus} />}
              </InputAdornment>
              {helperTextEmail}
            </span>
          }
          inputProps={{
            maxLength: 254,
            inputMode: "email",
            pattern: customEmailRegex,
          }}
          sx={globalTextFieldSx}
        />

        <Button
          variant="contained"
          fullWidth
          disabled={!customEmailRegex.test(email)}
          onClick={() => {
            const updatedCustomerData = (verifiedCustomerData || []).map(
              (c) => ({
                ...c,
                EMAIL: email,
              }),
            );

            if (!isEmpty(updatedCustomerData)) {
              setVerifiedCustomerData(updatedCustomerData);
              handleSubmit(updatedCustomerData);
            } else {
              setPopUpFlow("please try again later!");
            }
          }}
        >
          Submit
        </Button>
      </Box>
    );
  };

  const renderPopUpFlows = () => {
    switch (popUpFlow) {
      case "dob":
        return renderDOBFlow();
      case "pan":
        return renderPANFlow();
      case "confirmPanDetails":
        return renderConfirmPANFlow();
      case "email":
        return renderEmailFlow();
      default:
        return null;
    }
  };

  return (
    <>
      <CustomPopup
        className={
          width < tabViewPoint
            ? "revamp-onBoarding-popup"
            : "revamp-onBoarding-popup-web"
        }
        open={open}
        handleOpen={handleClosePopUp}
        btnLabel={!btnLoading ? "Go back" : ""}
        btnStartIcon={
          !btnLoading ? (
            <KeyboardArrowLeftIcon sx={{ width: "1.1rem", height: "1.1rem" }} />
          ) : (
            <></>
          )
        }
      >
        {btnLoading ? (
          <RevampOnboardingLoader preLoadedGif={preLoadedGif} />
        ) : (
          renderPopUpFlows()
        )}
      </CustomPopup>
    </>
  );
};

export default RevampOnboardingPopup;
